import React from "react";
import WanImg from "../../../../assets/images/WAN.jpg";

import './styles.css';

const Wan = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>WAN</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={WanImg} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Wan;